import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createPartner,
  CreatePartnerPayload,
  Partner,
} from '../../api/queries';

const PARTNERS_QUERY_KEY = ['GET_PARTNERS'];

export const useCreatePartnerMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreatePartnerPayload): Promise<Partner> => {
      return createPartner(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PARTNERS_QUERY_KEY });
    },
  });
};
